import { cn } from "@utils";
import { Controller } from "react-hook-form";

const BaseCheckbox = ({
  checked,
  onChange,
  onBlur,
  readonly,
  disabled,
  className,
}) => {
  return (
    <div
      className={cn(
        "group absolute left-4 top-1/2 -mt-2 grid size-4 grid-cols-1 group-has-[:disabled]:opacity-60 group-has-[:disabled]:cursor-default",
        className
      )}
    >
      <input
        type="checkbox"
        className="col-start-1 row-start-1 appearance-none rounded border border-zinc-300 bg-white checked:border-primary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-zinc-300 disabled:bg-zinc-100 disabled:checked:bg-zinc-100 forced-colors:appearance-auto cursor-pointer disabled:cursor-default"
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readonly}
        disabled={disabled}
      />
      <svg
        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-zinc-950/25"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          className="opacity-0 group-has-[:checked]:opacity-100"
          d="M3 8L6 11L11 3.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="opacity-0 group-has-[:indeterminate]:opacity-100"
          d="M3 7H11"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

const Checkbox = (props) => {
  const { control, name, onChange, ...rest } = props;

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange: fieldOnChange, onBlur } }) => (
          <BaseCheckbox
            {...rest}
            checked={value}
            onChange={(e) => {
              fieldOnChange(e.target.checked);
              if (onChange) onChange(e);
            }}
            onBlur={onBlur}
          />
        )}
      />
    );
  }

  return <BaseCheckbox {...props} />;
};

export default Checkbox;
